export const PLATFORM_IOS_UA_MARKER = 'SHW iOS'

export enum PlatformRuntime {
  web = 'web',
  ios = 'ios-app',
  android = 'android-app',
}

// Constructing these as numbers, so we can do things
// like user.platformDevice <= PlatformDevice.TABLET
export enum PlatformDevice {
  MOBILE = 1,
  // TABLET = 2,
  // ^ Maybe it'll be useful one day?
  DESKTOP = 3,
}

export interface WebPushNotificationsInterface {
  isSupported: boolean
  isEnabled: boolean
  toggleSubscription: () => Promise<void>
  element: JSX.Element | null
}
